function getDeviceId () {
  return (global !== undefined && global.deviceId !== undefined) ? global.deviceId : ''
}

export default getDeviceId
